import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "class-compare-container" }
const _hoisted_2 = { class: "filter-section" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-actions" }
const _hoisted_5 = { class: "class-selector-container" }
const _hoisted_6 = { class: "class-selector-item" }
const _hoisted_7 = { class: "class-selector-item" }
const _hoisted_8 = { class: "compare-button-container" }
const _hoisted_9 = { class: "display-option" }
const _hoisted_10 = {
  key: 1,
  class: "comparison-results"
}
const _hoisted_11 = { class: "summary-cards" }
const _hoisted_12 = { class: "summary-card total-score-card" }
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = { class: "class-name" }
const _hoisted_15 = { class: "score" }
const _hoisted_16 = { class: "summary-item" }
const _hoisted_17 = { class: "class-name" }
const _hoisted_18 = { class: "score" }
const _hoisted_19 = { class: "summary-card pass-rate-card" }
const _hoisted_20 = { class: "summary-item" }
const _hoisted_21 = { class: "class-name" }
const _hoisted_22 = { class: "rate" }
const _hoisted_23 = { class: "summary-item" }
const _hoisted_24 = { class: "class-name" }
const _hoisted_25 = { class: "rate" }
const _hoisted_26 = { class: "summary-card pass-count-card" }
const _hoisted_27 = { class: "summary-item" }
const _hoisted_28 = { class: "class-name" }
const _hoisted_29 = { class: "count" }
const _hoisted_30 = { class: "summary-item" }
const _hoisted_31 = { class: "class-name" }
const _hoisted_32 = { class: "count" }
const _hoisted_33 = { class: "analysis-card" }
const _hoisted_34 = {
  key: 0,
  class: "table-container"
}
const _hoisted_35 = {
  key: 0,
  class: "analysis-card"
}
const _hoisted_36 = { class: "chart-container" }
const _hoisted_37 = {
  key: 1,
  class: "analysis-card"
}
const _hoisted_38 = { class: "chart-container" }
const _hoisted_39 = { class: "analysis-card" }
const _hoisted_40 = { class: "top-students-container" }
const _hoisted_41 = { class: "class-top-students" }
const _hoisted_42 = { class: "class-top-students" }
const _hoisted_43 = {
  key: 2,
  class: "no-data"
}

import { ref, onMounted, computed } from 'vue';
import { message } from 'ant-design-vue';
import VChart from 'vue-echarts';
import { getClassesApi } from '@/servers/api/classes';
import { getClassExam } from '@/servers/api/grade';
import { getClassCompare } from '@/servers/api/grade';
import { useUserStore } from '@/store';
import { Row, Col, Card, Button, Empty, Alert, Select, Spin, Radio, Table } from "ant-design-vue";

// 类型定义 
interface ClassInfo {
  id: number;
  name: string;
  header: string | null;
  school_id: string | null;
  subject_selection: string; // 新增：科目选择
}

interface ExamInfo {
  id: number;
  name: string;
}

interface StudentInfo {
  id: number;
  student_id: number;
  student_name: string;
  total_score: number; // 总分
  [key: string]: any;
}

interface SubjectScores {
  '总分': number;
  '语文': number;
  '数学': number;
  '英语': number;
  '物理': number;
  '化学': number;
  '历史': number;
  '政治': number;
  '生物': number;
  '地理': number;
}

interface ComparisonResult {
  top_3: {
    current: StudentInfo[];
    compare: StudentInfo[];
  };
  pass_rate: {
    current: number;
    compare: number;
  };
  pass_count: {
    current: number;
    compare: number;
  };
  subject_top_score: {
    current: SubjectScores;
    compare: SubjectScores;
  };
  subject_average_score: {
    current: SubjectScores;
    compare: SubjectScores;
  };
}

// 状态管理

export default /*@__PURE__*/_defineComponent({
  __name: 'ClassCompare',
  setup(__props) {

const userStore = useUserStore();
const loading = ref(false);
const hasSearched = ref(false);
const allClassList = ref<ClassInfo[]>([]);
const classList = ref<ClassInfo[]>([]);
const examList = ref<ExamInfo[]>([]);
const selectedClass1 = ref<number>();
const selectedClass2 = ref<number>();
const selectedExamId = ref<number>(0);
const displayMode = ref<'table' | 'chart'>('table');
const comparisonData = ref<ComparisonResult | null>(null);
const currentClass = ref<ClassInfo>({ id: 0, name: '', header: null, school_id: null, subject_selection: '' });
// 科目名称映射（中文科目名）
const subjectMap = {
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '政治': '政治',
  '地理': '地理'
};

// 计算差值
const totalScoreDiff = computed(() => {
  if (!comparisonData.value) return 0;
  return comparisonData.value.subject_average_score.current['总分'] -
         comparisonData.value.subject_average_score.compare['总分'];
});

const passRateDiff = computed(() => {
  if (!comparisonData.value) return 0;
  return (comparisonData.value.pass_rate.current - comparisonData.value.pass_rate.compare) * 100;
});

const passCountDiff = computed(() => {
  if (!comparisonData.value) return 0;
  return comparisonData.value.pass_count.current - comparisonData.value.pass_count.compare;
});

// 格式化科目平均分数据（用于图表）
const subjectAverageData = computed(() => {
  if (!comparisonData.value) return [];
  
  return Object.entries(subjectMap).map(([en, cn]) => ({
    subject: cn,
    class1Score: comparisonData.value!.subject_average_score.current[en as keyof SubjectScores] || 0,
    class2Score: comparisonData.value!.subject_average_score.compare[en as keyof SubjectScores] || 0,
    diff: (comparisonData.value!.subject_average_score.current[en as keyof SubjectScores] || 0) - 
          (comparisonData.value!.subject_average_score.compare[en as keyof SubjectScores] || 0)
  })).filter(item => item.class1Score > 0 || item.class2Score > 0); // 过滤无效科目
});

// 格式化科目最高分数据（用于图表）
const subjectTopData = computed(() => {
  if (!comparisonData.value) return [];
  
  return Object.entries(subjectMap).map(([en, cn]) => {
    const class1Top = comparisonData.value!.subject_top_score.current[en as keyof SubjectScores] || 0;
    const class2Top = comparisonData.value!.subject_top_score.compare[en as keyof SubjectScores] || 0;
    return {
      subject: cn,
      class1Top,
      class2Top,
      diff: class1Top - class2Top
    };
  }).filter(item => item.class1Top > 0 || item.class2Top > 0); // 过滤无效科目
});

// 合并表格数据源
const mergedSubjectTableData = computed(() => {
  if (!comparisonData.value) return [];
  
  return Object.entries(subjectMap).map(([en, cn]) => {
    // 平均分数据
    const class1AvgScore = comparisonData.value!.subject_average_score.current[en as keyof SubjectScores] || 0;
    const class2AvgScore = comparisonData.value!.subject_average_score.compare[en as keyof SubjectScores] || 0;
    const avgDiff = class1AvgScore - class2AvgScore;
    
    // 最高分数据
    const class1TopScore = comparisonData.value!.subject_top_score.current[en as keyof SubjectScores] || 0;
    const class2TopScore = comparisonData.value!.subject_top_score.compare[en as keyof SubjectScores] || 0;
    const topDiff = class1TopScore - class2TopScore;
    
    return {
      subject: cn,
      // 平均分相关
      class1AvgScore,
      class2AvgScore,
      avgDiff,
      // 最高分相关
      class1TopScore,
      class2TopScore,
      topDiff
    };
  }).filter(item => item.class1AvgScore > 0 || item.class2AvgScore > 0 || item.class1TopScore > 0 || item.class2TopScore > 0);
});

// 合并表格列定义
const mergedSubjectTableColumns = computed(() => [
  { title: '科目', dataIndex: 'subject', key: 'subject', align: 'center' },
  // 平均分分组
  { 
    title: `${getClassName(selectedClass1.value)} 平均分`, 
    dataIndex: 'class1AvgScore', 
    key: 'class1AvgScore', 
    align: 'center'
  },
  { 
    title: `${getClassName(selectedClass2.value)} 平均分`, 
    dataIndex: 'class2AvgScore', 
    key: 'class2AvgScore', 
    align: 'center'
  },
  { 
    title: '平均分差值(我的班级-挑战班级)', 
    dataIndex: 'avgDiff', 
    key: 'avgDiff', 
    align: 'center'
  },
  // 最高分分组
  { 
    title: `${getClassName(selectedClass1.value)} 最高分`, 
    dataIndex: 'class1TopScore', 
    key: 'class1TopScore', 
    align: 'center'
  },
  { 
    title: `${getClassName(selectedClass2.value)} 最高分`, 
    dataIndex: 'class2TopScore', 
    key: 'class2TopScore', 
    align: 'center'
  },
  { 
    title: '最高分差值(我的班级-挑战班级)', 
    dataIndex: 'topDiff', 
    key: 'topDiff', 
    align: 'center'
  }
]);

const topStudentColumns = [
  { title: '班级排名', dataIndex: 'class_rank', key: 'class_rank', customRender: ({ record }: any) => record?.subjects?.['总分']?.class_rank ?? '-' },
  { title: '姓名', dataIndex: 'student_name', key: 'student_name' },
  { title: '总分', dataIndex: 'total_score', key: 'total_score', render: (val: number) => formatScore(val) }
];

// 图表配置
const subjectChartOption = computed(() => {
  if (!comparisonData.value) return {};
  
  const validSubjects = subjectAverageData.value;
  const subjects = validSubjects.map(item => item.subject);
  const class1Scores = validSubjects.map(item => item.class1Score);
  const class2Scores = validSubjects.map(item => item.class2Score);
  
  return {
    tooltip: { 
      trigger: 'axis', 
      axisPointer: { type: 'shadow' },
      formatter: (params: any) => {
        return `${params[0].name}: ${formatScore(params[0].value)}<br/>${params[1].name}: ${formatScore(params[1].value)}`;
      }
    },
    legend: { data: [getClassName(selectedClass1.value), getClassName(selectedClass2.value)] },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: subjects },
    yAxis: { type: 'value', name: '分数' },
    series: [
      {
        name: getClassName(selectedClass1.value),
        type: 'bar',
        data: class1Scores,
        itemStyle: { color: '#5470C6' },
        label: {
          show: true,
          position: 'top',
          formatter: (params: any) => formatScore(params.value),
          fontSize: 12,
          color: '#333'
        }
      },
      {
        name: getClassName(selectedClass2.value),
        type: 'bar',
        data: class2Scores,
        itemStyle: { color: '#91CC75' },
        label: {
          show: true,
          position: 'top',
          formatter: (params: any) => formatScore(params.value),
          fontSize: 12,
          color: '#333'
        }
      }
    ]
  };
});

const subjectTopChartOption = computed(() => {
  if (!comparisonData.value) return {};
  
  const validSubjects = subjectTopData.value;
  const subjects = validSubjects.map(item => item.subject);
  const class1Tops = validSubjects.map(item => item.class1Top);
  const class2Tops = validSubjects.map(item => item.class2Top);
  
  return {
   tooltip: { 
     trigger: 'axis', 
     axisPointer: { type: 'shadow' },
     formatter: (params: any) => {
       return `${params[0].name}: ${formatScore(params[0].value)}<br/>${params[1].name}: ${formatScore(params[1].value)}`;
     }
   },
    legend: { data: [getClassName(selectedClass1.value), getClassName(selectedClass2.value)] },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', data: subjects },
    yAxis: { type: 'value', name: '分数' },
    series: [
      {
        name: getClassName(selectedClass1.value),
        type: 'bar',
        data: class1Tops,
        itemStyle: { color: '#5470C6' },
         label: {
          show: true,
          position: 'top',
          formatter: (params: any) => formatScore(params.value),
          fontSize: 12,
          color: '#333'
        }
      },
      {
        name: getClassName(selectedClass2.value),
        type: 'bar',
        data: class2Tops,
        itemStyle: { color: '#91CC75' },
        label: {
          show: true,
          position: 'top',
          formatter: (params: any) => formatScore(params.value),
          fontSize: 12,
          color: '#333'
        }
      }
    ]
  };
});

// 工具函数 
const getClassName = (classId: number | undefined) => {
  if (!classId) return '';
  const cls = allClassList.value.find(c => c.id === classId);
  return cls ? cls.name : '未知班级';
};

const getDifferenceClass = (diff: number) => {
  if (diff > 0) return 'positive'; // 我方更高 → 绿色
  if (diff < 0) return 'negative'; // 我方更低 → 红色
  return 'zero';                   // 相等 → 灰色
};

// 格式化分数
const formatScore = (score: number) => {
  return score.toFixed(2);
};

// 格式化通过率
const formatRate = (rate: number) => {
  return (rate * 100).toFixed(2) + '%';
};

// 格式化通过率差值
const formatRateDiff = (diff: number) => {
  return diff.toFixed(2) + '%';
};

const handleExamChange = (examId: number) => {
  selectedExamId.value = examId;
};

const fetchComparisonData = async () => {
  if (selectedClass1.value === selectedClass2.value) {
    message.warning('请选择不同的班级进行对比');
    return;
  }
  
  if (!selectedClass1.value || !selectedClass2.value || !selectedExamId.value) {
    message.warning('请选择完整的对比条件');
    return;
  }
  
  try {
    loading.value = true;
    hasSearched.value = true;

    const res = await getClassCompare({
      class_id: selectedClass1.value,
      compare_class_id: selectedClass2.value,
      exam_id: selectedExamId.value
    });

    if (res) {
      comparisonData.value = res;
    } else {
      message.error(res?.msg || '获取对比数据失败');
      comparisonData.value = null;
    }
  } catch (err: any) {
    const errorMsg = err?.data?.data || '获取对比数据失败，注意只能对比同一年级的班级';
    message.error(errorMsg);
    comparisonData.value = null;
  } finally {
    loading.value = false;
  }
};

// 重置筛选
const resetFilters = () => {
  if (examList.value.length > 0) {
    selectedExamId.value = examList.value[examList.value.length - 1].id;
  }
  if (classList.value.length > 0) {
    selectedClass2.value = classList.value[0].id;
  }
  comparisonData.value = null;
  hasSearched.value = false;
};

// 计算"开始对比"按钮的禁用状态
const isCompareBtnDisabled = computed(() => {
  return (
    loading.value || 
    !selectedClass1.value || 
    !selectedClass2.value || 
    !selectedExamId.value || 
    selectedClass1.value === selectedClass2.value
  );
});

// 初始化数据
const init = async () => {
  try {
    const userInfo = userStore.getUserInfo();
    const teacherId = String(userInfo?.role || userInfo?.teacher?.uid || '').trim();
    
    if (!teacherId) {
      message.error('未获取到教师信息');
      return;
    }
    
    loading.value = true;
    const classRes = await getClassesApi({});
    
    if (classRes.code === 200 && classRes.data.length > 0) {
      allClassList.value = classRes.data;

      if (allClassList.value.length === 0) {
        message.warning('未找到可用班级');
        loading.value = false;
        return;
      }

      const myClass = allClassList.value.find(cls => String(cls.header || '').trim() === teacherId);
      if (!myClass) {
        // 兼容非班主任教师：回退到全班级模式
        currentClass.value = allClassList.value[0];
        selectedClass1.value = currentClass.value.id;
        classList.value = allClassList.value.filter(cls => cls.id !== currentClass.value.id);
        if (classList.value.length > 0) {
          selectedClass2.value = classList.value[0].id;
        }
        message.warning('未找到班主任绑定班级，已切换为全班级对比');
      } else {
        currentClass.value = myClass;
        selectedClass1.value = myClass.id;
        const myClassIdPrefix = myClass.id.toString().slice(0, 2); 
        const myClassSubject = myClass.subject_selection || ''; 
        classList.value = allClassList.value.filter(cls => {
          const isNotMyClass = cls.id !== myClass.id;
          const isSameIdPrefix = cls.id.toString().slice(0, 2) === myClassIdPrefix;
          const isSameSubject = (cls.subject_selection || '') === myClassSubject;
          return isNotMyClass && isSameIdPrefix && isSameSubject;
        });
        if (classList.value.length > 0) {
          selectedClass2.value = classList.value[0].id;
        } else {
          selectedClass2.value = undefined;
          message.warning(`暂无符合条件的挑战班级（需满足：ID前两位为"${myClassIdPrefix}"且科目选择为"${myClassSubject}"）`);
        }
      }
    } else {
      message.error(classRes.msg || '获取班级列表失败');
    }
    if (currentClass.value.id) {
      const examRes = await getClassExam({ class_id: currentClass.value.id });
      if (examRes.code === 200 && examRes.data.length > 0) {
        examList.value = examRes.data.map((exam: any) => ({
          id: exam.id,
          name: exam.name
        }));
        if (examList.value.length > 0) {
          selectedExamId.value = examList.value[examList.value.length - 1].id;
        }
      } else {
        message.warning(examRes.msg || '获取考试列表失败');
      }
    }
    fetchComparisonData();
  } catch (err) {
    message.error('初始化失败');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "班级对比"),
      _createElementVNode("p", null, "选择考试和班级进行对比分析")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [16, 16] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 24,
            md: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filter-label" }, "考试：", -1)),
                _createVNode(_component_a_select, {
                  value: selectedExamId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedExamId).value = $event)),
                  placeholder: "选择考试",
                  style: {"width":"100%"},
                  onChange: handleExamChange,
                  disabled: loading.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examList.value, (exam) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: exam.id,
                        value: exam.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(exam.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            span: 24,
            md: 16
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: resetFilters
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("重置筛选", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, {
        gutter: [16, 16],
        style: {"margin-top":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "我的班级：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedClass1.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedClass1).value = $event)),
                    placeholder: "选择班级",
                    style: {"flex":"1"},
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allClassList.value, (cls) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cls.id,
                          value: cls.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cls.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "versus" }, "VS", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "挑战班级：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedClass2.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedClass2).value = $event)),
                    placeholder: "选择班级",
                    style: {"flex":"1"},
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classList.value, (cls) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cls.id,
                          value: cls.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cls.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: fetchComparisonData,
                    disabled: isCompareBtnDisabled.value,
                    class: "compare-button"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" 开始对比 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_9, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "显示方式：", -1)),
        _createVNode(_component_a_radio_group, {
          value: displayMode.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((displayMode).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio, { value: "table" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("表格", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_radio, { value: "chart" }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("图表", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_a_spin, {
          key: 0,
          tip: "加载中...",
          class: "loading-spin"
        }))
      : _createCommentVNode("", true),
    (!loading.value && comparisonData.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_row, { gutter: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[13] || (_cache[13] = _createElementVNode("h3", null, "总分平均分", -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(getClassName(selectedClass1.value)), 1),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(formatScore(comparisonData.value.subject_average_score.current['总分'])), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(getClassName(selectedClass2.value)), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(formatScore(comparisonData.value.subject_average_score.compare['总分'])), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getDifferenceClass(totalScoreDiff.value)])
                      }, " 差值: " + _toDisplayString(formatScore(Math.abs(totalScoreDiff.value))), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[14] || (_cache[14] = _createElementVNode("h3", null, "特控通过率", -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(getClassName(selectedClass1.value)), 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(formatRate(comparisonData.value.pass_rate.current)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(getClassName(selectedClass2.value)), 1),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(formatRate(comparisonData.value.pass_rate.compare)), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getDifferenceClass(passRateDiff.value)])
                      }, " 差值: " + _toDisplayString(formatRateDiff(Math.abs(passRateDiff.value))), 3)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  span: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[15] || (_cache[15] = _createElementVNode("h3", null, "特控通过人数", -1)),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(getClassName(selectedClass1.value)), 1),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(comparisonData.value.pass_count.current), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(getClassName(selectedClass2.value)), 1),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(comparisonData.value.pass_count.compare), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["difference", getDifferenceClass(passCountDiff.value)])
                      }, " 差值: " + _toDisplayString(Math.abs(passCountDiff.value)), 3)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_a_card, {
              title: "科目平均分 & 最高分对比",
              class: "chart-card"
            }, {
              default: _withCtx(() => [
                (displayMode.value === 'table')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createVNode(_component_a_table, {
                        "data-source": mergedSubjectTableData.value,
                        bordered: "",
                        columns: mergedSubjectTableColumns.value,
                        pagination: false,
                        rowKey: "subject"
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.dataIndex === 'avgDiff' || column.dataIndex === 'topDiff')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(getDifferenceClass(record[column.dataIndex]))
                              }, _toDisplayString(formatScore(Math.abs(record[column.dataIndex]))), 3))
                            : (column.dataIndex.includes('Score') || column.dataIndex.includes('Top'))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(formatScore(Number(record[column.dataIndex]))), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(record[column.dataIndex]), 1)
                                ], 64))
                        ]),
                        _: 1
                      }, 8, ["data-source", "columns"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (displayMode.value === 'chart')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createVNode(_component_a_card, {
                  title: "科目平均分对比",
                  class: "chart-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_unref(VChart), {
                        option: subjectChartOption.value,
                        autoresize: "",
                        style: {"height":"400px"}
                      }, null, 8, ["option"])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (displayMode.value === 'chart')
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_a_card, {
                  title: "科目最高分对比",
                  class: "chart-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_unref(VChart), {
                        option: subjectTopChartOption.value,
                        autoresize: "",
                        style: {"height":"400px"}
                      }, null, 8, ["option"])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_a_card, {
              title: "班级前三名学生对比",
              class: "student-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 24,
                        md: 12
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("h4", null, _toDisplayString(getClassName(selectedClass1.value)) + " 前三名", 1),
                            _createVNode(_component_a_table, {
                              "data-source": comparisonData.value.top_3.current,
                              bordered: "",
                              columns: topStudentColumns,
                              pagination: false,
                              rowKey: "student_id"
                            }, null, 8, ["data-source"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 24,
                        md: 12
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("h4", null, _toDisplayString(getClassName(selectedClass2.value)) + " 前三名", 1),
                            _createVNode(_component_a_table, {
                              "data-source": comparisonData.value.top_3.compare,
                              bordered: "",
                              columns: topStudentColumns,
                              pagination: false,
                              rowKey: "student_id"
                            }, null, 8, ["data-source"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !comparisonData.value && hasSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createVNode(_component_a_empty, { description: "未找到对比数据，请选择其他班级或考试" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})